export default "__VITE_ASSET__DwVLoYIc__"